import { useForm } from 'react-hook-form'
import React, { useEffect, useState } from 'react'
import {
    createWeaponGroupItem, deleteWeaponGroupItem, getWeaponGroupItem,
    updateWeaponGroupItem
} from '../../../services/components/weaponGroups'
import {
    getWeaponCalibers,
    getWeaponCategories,
    getWeaponOperarions
} from "../../../services/components/weaponCategories";
import Select from "react-select";
import {
    WeaponGroupItemDTO
} from '../../../dtos/weaponGroups'

type WeaponGroupItemForm = {
    weaponGroupId: number
    weaponCategoryId: number
    weaponOperationId: number
    caliberIds: number[]
}

export default function WeaponGroupItemForm({itemToEdit}:any) {
    const { handleSubmit, reset, setValue } = useForm<WeaponGroupItemForm>()

    const [categories, setCategories] = useState<any[]>([])
    const [operations, setOperations] = useState<any[]>([])
    const [calibers, setCalibers] = useState<any>([])
    const [weaponGroupItem, setWeaponGroupItem] = useState<WeaponGroupItemDTO[]>([])

    const [success, setSuccess] = useState<string | null>(null)
    const [error, setError] = useState<string | null>(null)

    useEffect(() => {
        const fetchData = async () => {
            try {
                const [categoriesData, operationsData, calibersData] = await Promise.all([
                    getWeaponCategories(),
                    getWeaponOperarions(),
                    getWeaponCalibers(),
                ])

                setCategories(categoriesData)
                setOperations(operationsData)
                setCalibers(calibersData)

                const item :WeaponGroupItemDTO[] | undefined = await getWeaponGroupItem(itemToEdit)
                setValue('weaponGroupId', itemToEdit)

                if (item){
                    setWeaponGroupItem(item)
                }
            } catch (err) {
                console.error(err)
                setError('Failed to load select options')
            }
        }
        fetchData()
    }, [])

    useEffect(() => {
        if (weaponGroupItem){
                setValue('weaponCategoryId', weaponGroupItem[0]?.weapon_category_id)
                setValue('weaponOperationId', weaponGroupItem[0]?.weapon_operation_id)
                setValue('caliberIds', weaponGroupItem[0]?.calibers.map((caliber: any) => caliber.id))
        }
    }, [weaponGroupItem])

    const onSubmit = async () => {
        try {
            for (const item of weaponGroupItem) {
                const payload = {
                    weaponGroupId: item.weapon_group_id,
                    weaponCategoryId: item.weapon_category_id,
                    weaponOperationId: item.weapon_operation_id,
                    caliberIds: item.calibers.map((c: any) => c.id),
                };
                if (item.id) {
                    await updateWeaponGroupItem(item.id, payload)
                } else {
                    await createWeaponGroupItem(payload)
                }
            }
            setSuccess('Itens do grupo de armas salvos com sucesso!')
            setError(null)
            reset()
        } catch (e) {
            setError('Erro ao salvar itens do grupo de armas')
            setSuccess(null)
        }
    }

    const addWeaponGroupItem = () => {
        let item :WeaponGroupItemDTO = {
        "weapon_group_id": itemToEdit,
        "weapon_category_id": 0,
        "weapon_operation_id": 0,
        "calibers": [],
    }
        setWeaponGroupItem(prev => [...prev, item]);
    }

    const removeItem = async (index: number) => {
        const item = weaponGroupItem[index];
        if (item.id) {
            try {
                await deleteWeaponGroupItem(item.id);
            } catch (e) {
                setError('Erro ao deletar item');
                return;
            }
        }
        setWeaponGroupItem(prev => prev.filter((_, i) => i !== index));
    }

    const handleWeaponGroupItemChange = (index: number, field: string, value: any) => {
        setWeaponGroupItem((prevState) => {
            const newWeaponGuides = [...prevState];
            newWeaponGuides[index] = {
                ...newWeaponGuides[index],
                [field]: value,
            };
            return newWeaponGuides;
        });
    };

    return (
        <div className="col-lg-12">
            <h3 className="text-xl mb-4">Calibres</h3>
            
            <div>
                <div className="col-md-12 my-3">
                    <button type="button" onClick={addWeaponGroupItem} className="btn btn-sm btn-primary"><i
                        className="bi bi-plus-square-fill">&nbsp;</i> Adicionar item
                    </button>
                </div>
            </div>
            
            <form onSubmit={handleSubmit(onSubmit)} autoComplete='off'>
                {weaponGroupItem &&(
                    <>
                        {weaponGroupItem.map((weaponGuide, index) => (
                            <>
                                <div className="card">
                                    <div className="card-body">
                                        <div className="row mt-1">
                                            <div className="col-9 ps-0">
                                                <span className="badge rounded-pill bg-primary-subtle border-primary-subtle text-primary-emphasis m-2">{index + 1}</span>
                                            </div>
                                            <div className="col-3 text-end">
                                                <button type="button" onClick={() => removeItem(index)} className="btn btn-sm btn-danger my-2"><i className="bi bi-x-lg"></i></button>
                                            </div>
                                        </div>
                                        
                                        <div className="row g-3 mt-2">

                                            <div className="col-md-4">
                                                <label htmlFor="weapon_category_id" className="form-label">Tipo da
                                                    guia <i
                                                        className="text-danger"> *</i></label>
                                                <Select
                                                    options={categories}
                                                    name='weapon_category_id'
                                                    id='weapon_category_id'
                                                    onChange={(data: any) => {
                                                        handleWeaponGroupItemChange(index, 'weapon_category_id', data.value)
                                                    }}
                                                    noOptionsMessage={() => 'Nenhum registro encontrado'}
                                                    value={categories.find((option: {
                                                        value: any;
                                                    }) => option.value == weaponGuide?.weapon_category_id) || ''}
                                                    placeholder='Tipo de guia'
                                                />
                                            </div>

                                            <div className="col-md-4">
                                                <label htmlFor="weapon_operation_id" className="form-label">Funcionamento<i
                                                    className="text-danger"> *</i></label>
                                                <Select
                                                    options={operations}
                                                    name='weapon_operation_id'
                                                    id='weapon_operation_id'
                                                    onChange={(data: any) => {
                                                        handleWeaponGroupItemChange(index, 'weapon_operation_id', data.value)
                                                    }}
                                                    value={operations.find((option: {
                                                        value: any;
                                                    }) => option.value == weaponGuide?.weapon_operation_id) || ''}
                                                    noOptionsMessage={() => 'Nenhum registro encontrado'}
                                                    placeholder='Funcionamento'
                                                />
                                            </div>

                                            <div className="col-md-12">
                                                <label htmlFor="weapon_operation_id" className="form-label">Calibre(s)<i
                                                    className="text-danger"> *</i></label>
                                                <Select
                                                    options={calibers}
                                                    isMulti
                                                    name="caliberIds"
                                                    id="caliberIds"
                                                    onChange={options => {
                                                        handleWeaponGroupItemChange(index, 'calibers', options ? options.map((opt) => ({
                                                            id: opt.value,
                                                            description: opt.label,
                                                        })) : [])
                                                    }}
                                                    value={calibers.filter((option: {
                                                        value: any
                                                    }) => weaponGuide?.calibers.map((caliber: any) => caliber?.id)?.includes(option?.value))}
                                                    noOptionsMessage={() => 'Nenhum registro encontrado'}
                                                    placeholder="Selecione os calibres"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>
                        ))}
                        <div>
                            <button type="submit" className="btn btn-success">Salvar</button>
                        </div>
                    </>
                )
                }
            </form>
        </div>
    )
}
